import { gql } from "@apollo/client";

export interface LANControllerMQTTConfig {
	domain: string
	password: string
	ipAddress?: string
}

export const LAN_CONTROLLER_MQTT_CONFIG = gql`
query MqttConfig($domain: String!, $lanControllerId: Int!) {
	controller {
		mqttConfig(domain: $domain, lanControllerId: $lanControllerId) {
			domain
			password
			ipAddress
		}
	}
}
`

export interface LANControllerMQTTConfigResponse {
	controller: {
		mqttConfig: LANControllerMQTTConfig | null
	}
}

export interface LANControllerMQTTConfigArgs {
	domain: string;
	lanControllerId: number;
}

